const TailwindHoverEnlarge = (scale = 110) => {
  const speed = 100;
  return `transition ease-in-out delay-${speed} hover:-translate-y-1 hover:scale-${scale} duration-${speed} `;
};

module.exports = { TailwindHoverEnlarge };
